<style>

.form-control-feedback {
 top: 33px;
  font-size: 18px;
  position: absolute;
  right: 7px;
  cursor: pointer;  
}
 
</style>
<template>
  <div class="body" id="body">
    <br />
    <notifications group="notify" position="top center"  />
    <div class="container">
      <div class="row justify-content-center">
         <div class="col-md-12 text-center" style="margin-top: 20px;">
            
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6" style="margin-top: 20px;">
  
          <div class="card card-color card-login">
            <div class="card-body">
               
              <div class="text-center">
                   <span>Login do parceiro abaixo</span>
              </div>               
              <form @submit="checkForm">
                <div class="form-group has-feedback">
                  <label for="login" class="control-label"></label>
                  <input type="text" class="form-control" v-model="payload.login" autocomplete="off" placeholder="login" />
                  
                </div>
                <div class="form-group has-feedback">
                  <label for="password" class="control-label"></label>
                  <input  :type="password" v-model="payload.senha"   class="form-control"  autocomplete="off"  placeholder="senha"  />
                  
                </div>
                <br />
                <button type="submit" :disabled="disabledLogin==1" class="btn btn-outline-primary float-right" >Entrar</button>
              </form>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>
<script>


import {Parceiro} from "@/soganhei"
import {ParceiroService} from "@/http"

export default {
  name: "Login",
  components: {},
  data: () => {
    return {
      password: "password",
      disabledLogin:0,
      payload: Parceiro, 
    };
  },
  methods: { 
      
     checkForm(e){
       
        e.preventDefault();
                 
        this.disabled = "disabled";
          
        const payload = Object.assign({},this.payload);

        this.disabledLogin = 1
        ParceiroService.LoginParceiro(payload).then(response=>{

           this.$cookies.set(process.env.VUE_APP_TOKEN_PARCEIRO,response.data)
           this.$router.push({name:"promocoes"});

        }).catch(error=>{
          
          window.console.error(error.response)
          this.disabledLogin = 0
          this.$notify({
              group: "notify",
              text: "Error para logar",
              type: "error"
          });
          

        })
        
      },
  }, 
  created(){

       ParceiroService.Ping().then(response=>{
              window.console.log(response.data)
           }).catch(error=>{
              window.console.error(error)
      })
  }
  
};
</script>


 
